import { ConsumptionNomenclatureDetail } from 'bus/consumptionNomenclature/types';

import { PayloadRequest } from 'types/requestTypes';

import $axios from '../utils/axios-instance';

export default class ConsumptionNomenclatureApi {
  async getConsumptionNomenclatureDetail({ id }: PayloadRequest) {
    return await $axios
      .get<ConsumptionNomenclatureDetail>(`/v1/ConsumptionNomenclature/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createConsumptionNomenclature(data: ConsumptionNomenclatureDetail) {
    return await $axios
      .post('/v1/ConsumptionNomenclature/', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeConsumptionNomenclature(data: ConsumptionNomenclatureDetail) {
    return await $axios
      .put(`/v1/ConsumptionNomenclature/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteConsumptionNomenclature({ id }: PayloadRequest) {
    return await $axios
      .delete(`/v1/ConsumptionNomenclature/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
